import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Divider, Typography } from '@mui/material'

import DateRangePicker from '../../../../../components/DateRangePicker/DateRangePicker'
import { defaultTrackedEventsStartTimestamp } from '../../../../live-events/const/const'
import { LiveEventExamplesControls } from '../../../../live-events/hooks/useLiveEventExamplesControls'
import { LiveEventGroupBy } from '../../../../live-events/utils/liveEventExamplesGrouping'
import { LiveEventGroupByToggle } from '../LiveEventGroupByToggle'

type LiveEventExamplesToolbarProps = {
  controls: LiveEventExamplesControls
  // Omit to hide the summary line (e.g. while the events are loading).
  resultCounts?: { eventCount: number; groupCount: number }
}

/** Date range and grouping controls above the Live Event Examples list, with the "Found N examples in M groups" summary. */
export const LiveEventExamplesToolbar: FC<LiveEventExamplesToolbarProps> = ({ controls, resultCounts }) => {
  const { t } = useTranslation()
  const { dateRange, handleDateRangeChange, hasAccessToBlueprints, groupBy, hideDiscontinuedBlueprints } = controls

  return (
    <>
      <Box sx={{ mt: 3, display: 'flex', alignItems: 'center', gap: 2 }}>
        <DateRangePicker value={dateRange} onChangeValue={handleDateRangeChange} minDate={defaultTrackedEventsStartTimestamp} />
        {hasAccessToBlueprints && (
          <>
            <Divider orientation="vertical" flexItem />
            <LiveEventGroupByToggle
              groupBy={groupBy}
              hideDiscontinuedBlueprints={hideDiscontinuedBlueprints}
              onGroupByChange={controls.handleGroupByChange}
              onHideDiscontinuedBlueprintsChange={controls.handleHideDiscontinuedBlueprintsChange}
            />
          </>
        )}
      </Box>

      {resultCounts && (
        <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
          {t(groupBy === LiveEventGroupBy.Blueprint ? 'implementations:found_events_in_blueprints' : 'implementations:found_events_in_types', {
            count: resultCounts.eventCount,
            eventCount: resultCounts.eventCount,
            groupCount: resultCounts.groupCount,
          })}
        </Typography>
      )}
    </>
  )
}
